import React from "react";
import { motion } from "framer-motion";


const Logo = ({
  src = "./logo.png",
  alt = "Logo",
  height = "inherit",
  width = "150px",
  style = {},
}) => {
  // Define animation variants
  const animationVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.8 } },
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={animationVariants}
      style={{
        // Use the height from props
        overflow: "hidden", // Ensures the image doesn't overflow the container
        display: "flex", // Center content inside
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically

        margin: "0px", // External margin
        padding: "0px", // Internal padding for the container
        // Ensure border and padding don't affect width/height
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          width: width, // Use the width from props
          height: height,
          objectFit: "cover", // Ensures the image covers the entire container
          borderRadius: "50%",
          borderRadius: "50%", // Circular container
          border: "2px solid #000", // Optional border around the circular container    // Make the image circular
          boxSizing: "border-box",
          ...style, // Merge any custom styles passed via props
        }}
      />
    </motion.div>
  );
};

export default Logo;
